import { React, useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const today = new Date();
  const currentDate = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();

  const navigate = useNavigate();

  const [disabled, setDisabled] = useState(false);
  const [input, setInput] = useState({
    date: currentDate,
    userName: "",
    email: "",
    mobile: "",
    subject: "Buy Artwork(SM)",
    comment: ""
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInput((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    console.log(input);
    fetch(
      "https://sheetdb.io/api/v1/rco7v07yf440c",
      {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: [
            input
          ]
        })
      }
    )
      .then((res) => res.json())
      .then((data) => {
        emailjs.send(
          'service_j5sbf0f',
          'template_ld2q3zt',
          {},
          'OJY8PZqEYlw3tfGwB'
        )
          .then(() => {
            setDisabled(false);
            alert("Thank you for your enquiry. We will get in touch with you ASAP!");
            navigate("/");
          })
          .catch((error) => {
            setDisabled(false);
            alert("Form saved, but failed to send email. Please try again.");
          });
      })
      .catch((error) => {
        setDisabled(false);
        alert("Your response was not submitted! Please try again.");
      });
  }

  return (
    <section className="px-8 sm:px-12 lg:px-24 py-10" id='contactNav'>
      <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold mb-5 font-heading">Contact Us</h1>
      <div className="flex justify-center font-para">
        <form
          className="w-full max-w-[600px] p-8 max-sm:p-4 bg-beige/60 rounded-lg shadow-lg"
          onSubmit={handleSubmit}
        >
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block text-brown-700 text-lg font-semibold mb-2"
            >
              Name
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="userName"
              value={input.name}
              onChange={handleChange}
              className="w-full rounded-lg shadow-inset py-2 px-4 text-brown-700 focus:outline-none focus:shadow-xl transition-all placeholder-brown-600"
              placeholder="Your Name"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="email"
              className="block text-brown-700 text-lg font-semibold mb-2"
            >
              Email
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={input.email}
              onChange={handleChange}
              className="w-full rounded-lg shadow-inset py-2 px-4 text-brown-700 focus:outline-none focus:shadow-xl transition-all placeholder-brown-600"
              placeholder="Your Email"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="mobile-nunm"
              className="block text-brown-700 text-lg font-semibold mb-2"
            >
              Mobile Number
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              id="mobile-num"
              name="mobile"
              value={input.mobile}
              onChange={handleChange}
              className="w-full rounded-lg shadow-inset py-2 px-4 text-brown-700 focus:outline-none focus:shadow-xl transition-all placeholder-brown-600"
              placeholder="Your Mobile Number"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="subject"
              className="block text-brown-700 text-lg font-semibold mb-2"
            >
              Subject
              <span style={{ color: "red" }}>*</span>
            </label>
            <select
              id="subject"
              name="subject"
              value={input.subject}
              onChange={handleChange}
              className="w-full rounded-lg shadow-inset py-2 px-4 text-brown-700 focus:outline-none focus:shadow-xl transition-all placeholder-brown-600"
            >
              <option value="Buy Artwork(SM)">Buy Artwork</option>
              <option value="Commission Work(SM)">Commission Work</option>
              <option value="Class Enquiry(SM)">Class Enquiry</option>
            </select>
          </div>

          <div className="mb-6">
            <label
              htmlFor="message"
              className="block text-brown-700 text-lg font-semibold mb-2"
            >
              Message
              <span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              id="message"
              name="comment"
              value={input.comment}
              onChange={handleChange}
              className="w-full rounded-lg shadow-inset py-2 px-4 text-brown-700 focus:outline-none focus:shadow-xl transition-all placeholder-brown-600"
              rows="5"
              placeholder="Your Message"
              required
            ></textarea>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="text-brown-700 text-xl sm:text-2xl font-semibold shadow-inset w-full sm:w-[50%] transition-all rounded-lg py-2 hover:shadow-xl hover:bg-beige"
              disabled={disabled}
            >
              {disabled ? "..." : "Submit!"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;